import * as form from '../form';

export const legalTechnologyNonCompliance = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Date: form.datecontrol(xitem.Date),
        Incident: form.textarea(xitem.Incident),
        Location: form.location(xitem.Location),
        NonComplianceReason:  form.textarea(xitem.NonComplianceReason),     
        NonComplianceDisciplinaryAction: form.checkboxgroup(xitem.NonComplianceDisciplinaryAction),   
        DisciplinaryActionExplanation: form.textarea(xitem.DisciplinaryActionExplanation),    
        DisciplinaryActionOtherExplanation: form.textarea(xitem.DisciplinaryActionOtherExplanation),
        NonComplianceIncidentLocation: form.checkboxgroup(xitem.NonComplianceIncidentLocation),
      },
    };
  });
  return {
    HasNonCompliance: form.branch(data.HasNonCompliance),
    List: form.collection(items, (data.List || {}).branch),
  };
};
